import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { AttendeeFeatureView, CatalogContextView, LoginPopupView, ForgotPasswordView, ResetPasswordView } from ".";
import { DefaultPopupView } from "./drawers/popup-drawer/popup-section.view";
import { DefaultDrawerView } from "./drawers/config-drawer/drawer-section.view";
import { cclBuilderDrawerRoutes } from "certain-common-library";
import { CatalogUuidResolver } from "../../modules/shared/resolvers/cataloguuid.resolver";

const featureRoutes: Routes = [
    {
        path: "attendee/:catalogUuid",
        resolve: {
            catalog: CatalogUuidResolver
        },
        component: AttendeeFeatureView,
        children: [
            {
                path: "catalog",
                component: CatalogContextView
            },
            { path: "**", redirectTo: "catalog" }
        ]
    },
    {
        path: "preview/:catalogUuid",
        resolve: {
            catalog: CatalogUuidResolver
        },
        component: AttendeeFeatureView,
        children: [
            {
                path: "catalog",
                component: CatalogContextView
            },
            { path: "**", redirectTo: "catalog" }
        ]
    },
    {
        outlet: "drawer",
        path: "config-drawer",
        component: DefaultDrawerView,
        children: [
            // {
            //     path: "cart",
            //     component: CartDrawerView
            // }
        ]
    },
    {
        outlet: "popup",
        path: "popup",
        component: DefaultPopupView,
        children: [
            {
                path: "login",
                component: LoginPopupView
            },
            {
                path: "forgotPassword",
                component: ForgotPasswordView
            },
            {
                path: "resetPassword",
                component: ResetPasswordView
            }
        ]
    },
    cclBuilderDrawerRoutes
];
@NgModule({
    imports: [RouterModule.forChild(featureRoutes)],
    exports: [RouterModule],
    providers: [CatalogUuidResolver]
})
export class AttendeeFeatureRoutingModule {
    title = "Attendee";
}
